import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { MixpanelService } from 'src/app/services/mixpanel/mixpanel.service';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
})
export class LogoutComponent implements OnInit {
  constructor(
    private router: Router,
    authService: AuthService,
    private mixpanelService: MixpanelService
  ) {
    if (authService.isLoggedIn()) {
      this.mixpanelService.track('Action: Logout');
      authService.logout().subscribe((redirected) => {
        // Normally the browser is already on its way to WorkOS to end the session there.
        // If that could not be arranged (a server error), go to the login page ourselves,
        // where the login waits for a click: WorkOS may still hold the session.
        if (!redirected) {
          authService.requireClickToLogin();
          this.router.navigate(['login']);
        }
      });
    } else {
      this.router.navigate(['login']);
    }
  }

  ngOnInit() {}
}
